import {Injectable, OnDestroy} from '@angular/core';
import {Event as RouterEvent, NavigationEnd, Router} from '@angular/router';
import {filter, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class RouterScrollService implements OnDestroy {

	scrollContainer: HTMLElement | null;
	#destroyed = new Subject();

	constructor(private router: Router) {
		this.scrollContainer = null;
	}

	ngOnDestroy(): void {
		this.#destroyed.next(undefined);
		this.#destroyed.complete();
	}

	enableScrollPositionRestoration(): void {
		this.router.events.pipe(
			takeUntil(this.#destroyed),
			filter((e: RouterEvent) => e instanceof NavigationEnd),
		).subscribe({
			next: () => {
				this.restoreScrollPosition();
			}
		});
	}

	private restoreScrollPosition(): void {
		setTimeout(() => {
			this.getScrollContainer().scrollTop = 0;
		}, 0);
	}

	private getScrollContainer(): HTMLElement {
		if (!this.scrollContainer) {
			this.scrollContainer = document.getElementById('app-content');
		}
		if (!this.scrollContainer) {
			this.scrollContainer = document.getElementById('app-scroll-fallback');
		}
		if (this.scrollContainer === null) {
			throw new Error('Scroll container not found.');
		}
		return this.scrollContainer;
	}
}
